import { useMutation } from "react-query";
import { put } from "shared/data";

export const useUpdateSla = () => {
    return useMutation("updateSla", {
        mutationFn: (payload) => put("/sla", payload),
    });
};
